<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    class="icon-alert-circle"
    :class="[`icon-alert-circle--color-${color}`]"
  >
    <path
      d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconAlertCircle',
    props: {
      width: {
        type: [Number, String],
        default: 24,
      },
      height: {
        type: [Number, String],
        default: 24,
      },
      color: {
        type: String,
        required: false,
        default: 'red',
        validator: (value) => {
          const COLORS = ['black', 'white', 'red', 'grey', 'light-grey'];
          return COLORS.includes(value);
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  .icon-alert-circle {
    &--color-black {
      fill: #000000;
    }
    &--color-white {
      fill: #ffffff;
    }
    &--color-red {
      fill: #eb5757;
    }
    &--color-grey {
      fill: var(--itr-grey-mid);
    }
    &--color-light-grey {
      fill: var(--itr-grey);
    }
  }
</style>
